<!--
일괄기능 — 대금상환 「정산확정 취소」 (TASK-161 사이클 14 #15 — 결정 49 a, 송금취소 일괄과 같은 공용 배치 컴포넌트 job)
------------------------------------
 - 버튼 (blade) → jobInit() → 모달. 대상 = 선택 항목 (CodPaymentIndexTrait::codBatchJson 의 items)
 - 정산확정 취소 가능 = 정산확정 건만. 정산확정이 아닌 건이 섞이면 안내하고 차단 (확인 비활성 — 선택 해제 후 재시도)
 - 결과 = 창고지급완료 복귀 · 정산확정금액 비움 (창고 정정 · 창고지급취소가 다시 가능)
 - 확인 → POST /admin/cod-payments/unconfirmations (ids[]) — 서버 Logic 거부 문구 = 그대로 alert (전체 롤백) · 성공 = 서버 msg alert 후 새로고침
 - 상태값 = batch.states
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-unconfirm-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">정산확정 취소</h3>

            <div class="uk-margin-small">
                선택 {{ targets.length }}건 (정산확정 {{ confirmedCount }}건)
                <div class="uk-margin-small-top">정산확정을 취소하면 창고지급완료로 돌아가고 정산확정금액이 비워집니다. 창고의 정정 · 창고지급취소가 다시 가능해집니다.</div>
                <div class="uk-text-danger cdp-unconfirm-blocked" v-if="otherCount > 0">
                    정산확정이 아닌 건이 {{ otherCount }}건 섞여 있어 정산확정 취소할 수 없습니다.
                    정산확정 건만 선택한 뒤 다시 진행해 주세요.
                </div>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-danger cdp-unconfirm-submit" type="button"
                        :disabled="busy || otherCount > 0 || confirmedCount === 0" @click="submit">정산확정 취소 확인</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from '../../cod-payment/popup-mixin';

    export default {
        mixins: [CodPopupMixin],
        props: {
            /**
             * 일괄기능 공유data (CodPaymentIndexTrait::codBatchJson)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 작업대상 아이템 (jobInit 시점 선택 항목)
                targets: [],
            };
        },
        computed: {
            // App\Code\CodPayment\State::CONFIRMED (batch.states.confirmed)
            confirmedCount() {
                let confirmed = parseInt(this.batch.states.confirmed, 10);
                return this.targets.filter((item) => parseInt(item.state, 10) === confirmed).length;
            },

            otherCount() {
                return this.targets.length - this.confirmedCount;
            },
        },
        methods: {
            // 작업초기화 (버튼 클릭 → 모달)
            jobInit() {
                this.targets = _.filter(this.batch.items, ['checked', true]);
                if (this.targets.length === 0) {
                    alert('선택된 대금상환이 없습니다.');
                    return;
                }
                if (this.confirmedCount === 0) {
                    alert('정산확정 취소할 수 있는 정산확정 건이 없습니다.');
                    return;
                }
                this.show();
            },

            submit() {
                if (this.busy || this.otherCount > 0 || this.confirmedCount === 0) {
                    return;
                }
                this.request('post', '/admin/cod-payments/unconfirmations', {
                    ids: _.map(this.targets, 'id'),
                }).then(this.done);
            },
        },
    }
</script>
